import React, { useEffect, useState } from "react";
import { SelectDevices } from "./SelectDevices";
import { getAccelerometer } from "../../../services/data/accelerometer";

const TITLE = "Accelerometer sensors";

export const ACCELEROMETER_ID = "accelerometer";
export const DEVICE_MOTION_ID = "deviceMotion";

const AccelerometerDevicesData = [
  // Device motion is always supported.
  {
    id: DEVICE_MOTION_ID,
    label: "Device motion",
  },
];

const SelectAccelerometerDevices = ({ selectedDevices, onChange, loadingDevices, disabled }) => {
  const [data, setData] = useState(AccelerometerDevicesData);

  useEffect(() => {
    loadingDevices.add(1);
    const acl = getAccelerometer();
    if (acl) {
      // Add accelerometer if supported.
      AccelerometerDevicesData.push({
        id: ACCELEROMETER_ID,
        label: "Accelerometer",
      });
    }
    setData(AccelerometerDevicesData);
    onChange(AccelerometerDevicesData);
    loadingDevices.done();
  }, []);

  return (
    <SelectDevices
      title={TITLE}
      data={data}
      selectedDevices={selectedDevices}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default SelectAccelerometerDevices;
